import * as actionTypes from "../ActionTypes";

export const actionUpdateGlobalLoaderSagaAction = (payload) => {
  return {
    type: actionTypes.APP_LOADING,
    payload: payload,
  };
};